<template>
    <div id="leaseAffirm">
        <table-title>订单详情</table-title>
        <div class="indent">
            <table v-if="JSON.stringify(data) != '{}'" width="90%" border="1" class="oneBorderColor" cellpadding="0" align="left" cellspacing="0">
                <tr>
                    <td>订单编号</td>
                    <td>{{data.orderNo}}</td>
                    <td>租借人</td>
                    <td>{{$options.filters['queryDict']('bizObjects','member',data.leaseeId)}}</td>
                    <td>标的物小类</td>
                    <td>{{$options.filters['queryDict']('target','type',data.targetType)}}</td>
                </tr>
                <tr>
                    <td>框架协议号</td>
                    <td>{{data.agreementNo}}</td>
                    <td>订单数量</td>
                    <td>{{data.orderAmount}}</td>
                    <td>确认数量</td>
                    <td>{{data.operateConfirmedAmount}}</td>
                </tr>
                <tr>
                    <td>状态</td>
                    <td>{{$options.filters['queryDict']('ENUM_MID-OPERATE-LEASE','order.LeaseOrderStatus',data.status)}}</td>
                    <td>预取交付时间</td>
                    <td>{{new Date(data.expectedDeliveryDate).Format("yyyy-MM-dd")}}</td>
                    <td>交付方式</td>
                    <td>{{$options.filters['queryDict']('ENUM_MID-OPERATE-LEASE','order.DeliveryMethod',data.deliveryMethod)}}</td>
                </tr>
                <tr>
                    <td>约定租期</td>
                    <td>{{data.rentTerm}}</td>
                    <td>是否清洗</td>
                    <td>{{$options.filters['queryDict'](null,'bitYesNo',data.cleaningRequired)}}</td>
                    <td>租借方联系人</td>
                    <td>{{$options.filters['queryDict']('bizObjects','contact',data.receiveContactId)}}</td>
                </tr>
                <tr>
                    <td>所在区域</td>
                    <td colspan="1">{{data.receiveArea?$options.filters['queryDict']('region','fullArea',data.receiveArea):''}}</td>
                    <td>收货地址</td>
                    <td colspan="3">{{data.receiveAddress}}</td>
                </tr>
            </table>
        </div>
        <table-title>订单确认信息</table-title>
        <Form ref="formValidate" :model="formDate" inline :label-width="120" :rules="ruleValidate">
            <FormItem label="订单号">
                <Input disabled v-model="formDate.orderNo" style="width:180px"></Input>
            </FormItem>
            <FormItem label="确认结果" prop="confirmResult">
                <dict-select :width="180" namespace="ENUM_MID-OPERATE-LEASE" id="orderService.LeaseOrderConfirmResult" :exclusion="[]" v-model="formDate.confirmResult"></dict-select>
            </FormItem>
            <template v-if="formDate.confirmResult === 'OK'">
                <FormItem label="确认数量" prop="confirmedTotalAmount">
                    <InputNumber :min="1" :max="data.orderAmount" v-model="formDate.confirmedTotalAmount" style="width:180px"></InputNumber>
                </FormItem>
            </template>
            <br />
            <FormItem label="备注">
                <Input v-model="formDate.ackComment" type="textarea" style="width:490px" />
            </FormItem>
        </Form>
        <div class="btn">
            <Button style="margin-left:-200px" @click="reset">重置</Button>
            <Button type="primary" style="margin-left:10px" @click="submit">提交</Button>
            <Button type="warning" style="margin-left:10px" @click="backtrack">返回</Button>
        </div>
    </div>
</template>

<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'
import dictSelect from '@/components/select/dict-select.vue'
import targetTypeCascader from '@/components/select/targetType-cascader'

export default {
    props: ['paramsData'],
    components: {
        tableTitle,
        dictSelect,
        targetTypeCascader,
    },
    data() {
        return {
            memberId: '',//参与人
            data: {},
            targetCodeList: [],//标的物编码
            formDate: {
                orderNo: '',
                confirmedTotalAmount: null,
                confirmResult: '',
                ackComment: ""
            },
            ruleValidate: {
                confirmedTotalAmount: [{ required: true, message: '确认数量不能为空' }],
                confirmResult: [{ required: true, message: "确认结果不能为空", trigger: 'change' }],
            },
        }
    },
    mounted() {
        this.data = this.paramsData
        this.formDate.orderNo = this.data.orderNo
    },
    methods: {
        submit() {
            this.$refs['formValidate'].validate((valid) => {
                if (valid) {
                    var data
                    if (this.data.deliveryMethod === 'DOORSTEP') {
                        if (this.formDate.confirmResult === "OK") {
                            data = {
                                url: 'MID-OPERATE-LEASE/messageService/orderService/orderConfirm',
                                body: {
                                    orderNo: this.formDate.orderNo,
                                    confirmResult: this.formDate.confirmResult,
                                    confirmedTotalAmount: this.formDate.confirmedTotalAmount,
                                    ackComment:this.formDate.ackComment,
                                    deliveryPlans: []
                                }
                            }

                        } else {
                            data = {
                                url: 'MID-OPERATE-LEASE/messageService/orderService/orderConfirm',
                                body: {
                                    orderNo: this.formDate.orderNo,
                                    confirmResult: this.formDate.confirmResult,
                                    ackComment:"",
                                    deliveryPlans: []
                                }
                            }
                        }

                    } else {
                        if (this.formDate.confirmResult === "OK") {
                            data = {
                                url: 'MID-OPERATE-LEASE/messageService/orderService/orderConfirm',
                                body: {
                                    orderNo: this.formDate.orderNo,
                                    confirmResult: this.formDate.confirmResult,
                                    confirmedTotalAmount: this.formDate.confirmedTotalAmount,
                                    ackComment:this.formDate.ackComment,
                                    deliveryPlans: []
                                }
                            }
                        } else {
                            data = {
                                url: 'MID-OPERATE-LEASE/messageService/orderService/orderConfirm',
                                body: {
                                    orderNo: this.formDate.orderNo,
                                    confirmResult: this.formDate.confirmResult,
                                    ackComment:"",
                                    deliveryPlans: []
                                }
                            }
                        }

                    }
                    this.invoke(data).then(res => {
                        if (!res) {
                            if (this.formDate.confirmResult === "OK") {
                                this.$Modal.confirm({
                                    title: '该订单确认成功，是否追加交付计划',
                                    okText: '是',
                                    cancelText: '否',
                                    onOk: () => {
                                        this.$router.push({ path: '/home/lease/backhanderLease', query: { orderNo: this.data.orderNo } })
                                        this.reset()
                                    },
                                    onCancel: () => {
                                        this.backtrack()
                                        this.reset()
                                    }
                                })
                            } else {
                                this.$Message.success("该订单拒绝成功！")
                                setTimeout(() => {
                                    this.backtrack()
                                    this.reset()
                                }, 1400)
                            }

                        }
                    });

                }
            })
        },
        // 重置
        reset() {
            this.$refs['formValidate'].resetFields();
            this.addShow = false
            this.formDate.ackComment = ""
        },
        //返回
        backtrack() {
            this.$emit('onFinish')
        },

    }

}
</script>

<style lang="scss" scoped>
.borderColor {
    border-bottom: 1px solid #eee;
    text-align: center;
    tr {
        td {
            padding: 5px 0;
        }
        th {
            background: #f8f8f9;
            color: #515a6e;
            border: 1px solid transparent;
            padding: 10px 0;
        }
    }
}
.btn {
    margin-top: 20px;
    text-align: center;
}
.indent {
    height: 230px;
    .oneBorderColor {
        margin-left: 10px;
        text-align: center;
        tr {
            height: 40px;
            td {
                width: 78px;
            }
            td:nth-child(2n-1) {
                width: 90px;
                font-weight: bold;
                background: #c6e2ff;
            }
        }
    }
}
</style>